(() => {
  'use strict';
  const node = document.getElementById('SchnapperCatalogConfig');
  if (!node || !window.SchnapperStore) return;
  const config = JSON.parse(node.textContent), S = window.SchnapperStore, L = config.labels, root = config.root || '/';
  const make = (tag, attrs = {}, text) => { const el = document.createElement(tag); for (const [key, value] of Object.entries(attrs)) el.setAttribute(key, String(value)); if (text != null) el.textContent = text; return el; };
  const money = value => new Intl.NumberFormat(config.locale === 'de' ? 'de-CH' : config.locale || 'de-CH', { style: 'currency', currency: config.currency || 'CHF' }).format(value / 100);
  const clean = value => String(value || '').normalize('NFC').toLowerCase().trim();
  const safeImage = value => { if (!value) return ''; try { const url = new URL(typeof value === 'object' ? value.src || value.url : value, location.origin); if (url.protocol !== 'https:' || ![location.hostname, 'cdn.shopify.com'].includes(url.hostname)) return ''; url.searchParams.set('width', '160'); return url.href; } catch { return ''; } };
  function aliases(value) {
    const normalized = S.normalizeQuery(value), terms = new Set([normalized]);
    const groups = [['Hülle', /handyhuelle|handyhülle|schutzhülle|schutzhuelle|huelle|hülle|phone case|\bcase\b|\bcover\b/i], ['Displayschutz', /panzerglas|schutzfolie|schutzglas|displayschutz|screen protector/i], ['Ladegerät', /ladegerät|ladegeraet|charger|netzteil/i]];
    for (const [word, pattern] of groups) if (pattern.test(value)) terms.add(normalized.replace(pattern, word));
    return [...terms].map(x => x.trim()).filter(x => x && x.length <= 100);
  }
  function cartModel(item) {
    const options = item.options_with_values || [];
    const chosen = options.find(o => /^(modell|model)$/i.test(o.name || ''))?.value;
    if (chosen) return S.model(chosen);
    const variant = String(item.variant_title || '').split(' / ')[0];
    if (variant && variant !== 'Default Title') return S.model(variant);
    return /\d+\s*[–-]\s*\d+/.test(item.product_title || '') ? '' : S.model(item.product_title || '');
  }
  function matchingVariant(product, wanted) {
    const modelIndex = (product.options || []).findIndex(o => /^(modell|model)$/i.test(typeof o === 'string' ? o : o.name));
    return (product.variants || []).find(v => {
      if (!v.available) return false;
      const modelValue = modelIndex >= 0 ? v.options?.[modelIndex] || v['option' + (modelIndex + 1)] : String(v.title || '').split(' / ')[0];
      const model = S.model(modelValue || '');
      if (!wanted || model !== wanted) return false;
      const countIndex = (product.options || []).findIndex(o => /stückzahl|pack|anzahl/i.test(typeof o === 'string' ? o : o.name));
      return countIndex < 0 || /^(1|1er|1 stück)$/i.test(String(v.options?.[countIndex] || v['option' + (countIndex + 1)] || '').trim());
    });
  }
  S.catalogHelpers = { aliases, cartModel, matchingVariant };
  function filterLinks() {
    for (const box of document.querySelectorAll('[data-sx-tag-filters]')) {
      if (box.dataset.ready) continue;
      box.dataset.ready = 'true';
      const selected = JSON.parse(box.querySelector('[data-sx-selected-tags]')?.textContent || '[]');
      for (const item of box.querySelectorAll('[data-sx-tag]')) {
        const link = item.querySelector('a'); if (!link) continue;
        link.setAttribute('aria-current', String(item.dataset.sxTagSelected === 'true'));
        const prefix = item.closest('[data-sx-tag-group]').dataset.sxTagGroup + ': ';
        const tags = selected.filter(t => !t.value.startsWith(prefix));
        if (item.dataset.sxTagSelected !== 'true') tags.push({ value: item.dataset.sxTag, slug: item.dataset.sxTagSlug });
        const url = new URL(box.dataset.sxCollectionUrl + (tags.length ? '/' + tags.map(t => t.slug).join('+') : ''), location.origin);
        for (const [key, value] of new URL(location.href).searchParams) if (key !== 'page' && key !== 'section_id') url.searchParams.set(key, value);
        link.href = url.pathname + url.search;
      }
      const clear = box.querySelector('[data-sx-filter-clear]');
      if (clear) { const url = new URL(clear.href); for (const [key, value] of new URL(location.href).searchParams) if (key !== 'page' && key !== 'section_id') url.searchParams.set(key, value); clear.href = url.pathname + url.search; }
    }
  }
  async function recoverSearch() {
    const term = new URL(location.href).searchParams.get('q'); if (!term) return;
    for (const box of document.querySelectorAll('[data-sx-search-recovery]')) {
      const links = box.querySelector('[data-sx-search-alternatives]'), results = box.querySelector('[data-sx-search-similar]');
      if (!links || !results || box.dataset.ready) continue;
      box.dataset.ready = 'true'; links.className = 'sx-search-alternatives'; results.className = 'sx-search-similar';
      const alternatives = aliases(term).filter(t => clean(t) !== clean(term));
      const token = S.model(term), models = JSON.parse(document.getElementById('SchnapperExperienceConfig')?.textContent || '{}').models || [];
      const model = token && models.find(m => S.model(m.title) === token);
      for (const word of alternatives) { const url = new URL(config.searchUrl, location.origin); url.searchParams.set('q', word); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last'); url.searchParams.set('options[unavailable_products]', 'last'); links.append(make('a', { href: url.pathname + url.search, class: 'sx-search-alternative' }, word)); }
      if (model) links.append(make('a', { href: model.url, class: 'sx-search-alternative' }, model.title));
      if (!alternatives.length && !model) continue;
      box.hidden = false;
      for (const word of alternatives.slice(0, 2)) {
        try {
          const data = await S.request(root + 'search/suggest.json?q=' + encodeURIComponent(word) + '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=hide');
          for (const p of data.resources?.results?.products || []) {
            if (results.querySelector('[data-product-id="' + String(p.id).replace(/[^0-9]/g, '') + '"]')) continue;
            const url = new URL(p.url, location.origin); if (url.origin !== location.origin) continue;
            const link = make('a', { href: url.pathname + url.search, 'data-product-id': String(p.id).replace(/[^0-9]/g, '') });
            const src = safeImage(p.image || p.featured_image?.url); if (src) link.append(make('img', { src, alt: '', width: 60, height: 60, loading: 'lazy' }));
            link.append(make('span', {}, p.title)); results.append(link);
          }
          if (results.children.length) break;
        } catch {}
      }
    }
  }
  let candidates, sequence = 0, timer;
  const sourceCandidates = async () => candidates ||= await S.request(config.recommendationsUrl).catch(() => []);
  function cartHosts() {
    const hosts = [];
    for (const host of document.querySelectorAll('cart-drawer .drawer__footer, #main-cart-footer .cart__blocks')) {
      let box = host.querySelector('[data-sx-cart-extras]');
      if (!box) {
        const drawer = Boolean(host.closest('cart-drawer'));
        box = make(drawer ? 'details' : 'section', { class: 'sx-cart-extras', 'data-sx-cart-extras': '', hidden: '' });
        if (drawer) host.append(box); else host.prepend(box);
      }
      hosts.push(box);
    }
    return hosts;
  }
  async function cartExtras() {
    const boxes = cartHosts(); if (!boxes.length || S.cartBusy || S.syncBusy) return;
    const request = ++sequence;
    try {
      const cart = await S.getCart(), source = await sourceCandidates();
      if (request !== sequence) return;
      boxes.forEach(b => { b.hidden = true; b.replaceChildren(); });
      if (!cart.items?.length) return;
      const inCart = new Set(cart.items.map(i => String(i.product_id))), suggestions = [];
      for (const item of cart.items) {
        const model = cartModel(item); if (!model) continue;
        const needsCase = /panzerglas|schutzfolie|displayschutz|hydrogel/i.test(item.product_title || '');
        const needsGlass = /hülle|hulle|huelle|case/i.test(item.product_title || '');
        if (needsCase === needsGlass || item.item_components?.length || /schutzset/i.test(item.product_title || '')) continue;
        const pairs = source.filter(p => needsCase ? p.kind === 'case' : p.kind === 'screen' || p.kind === 'camera');
        for (const pair of pairs) {
          if (suggestions.length >= 2) break;
          const p = await S.product(pair.handle); if (inCart.has(String(p.id)) || suggestions.some(x => x.product.id === p.id)) continue;
          const variant = matchingVariant(p, model); if (!variant || Number(variant.price) > 1500 || Number(variant.price) <= 0) continue;
          suggestions.push({ product: p, variant });
        }
      }
      if (request !== sequence || !suggestions.length) return;
      for (const box of boxes) {
        box.append(make(box.matches('details') ? 'summary' : 'h3', {}, L.related_title), make('p', {}, L.related_note));
        const status = make('p', { role: 'status', class: 'sx-catalog-status' });
        for (const { product: p, variant: v } of suggestions) {
          const row = make('div', { class: 'sx-cart-extra' }), href = root + 'products/' + encodeURIComponent(p.handle) + '?variant=' + encodeURIComponent(v.id), link = make('a', { href });
          const src = safeImage(v.featured_image || p.featured_image || p.images?.[0]);
          row.append(src ? make('img', { src, alt: '', width: 50, height: 50, loading: 'lazy' }) : make('span'));
          link.append(make('span', {}, p.title), make('small', {}, v.title), make('strong', {}, money(Number(v.price))));
          const add = make('button', { type: 'button', 'aria-label': L.add + ': ' + p.title + ', ' + v.title }, L.add);
          add.addEventListener('click', async () => {
            if (S.cartBusy || S.syncBusy || add.disabled) return;
            S.cartBusy = true; add.disabled = true; status.textContent = L.adding;
            let added = false;
            try {
              await S.request(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
              added = true; status.textContent = L.added; S.notifyCart?.();
              if (S.syncCart) await S.syncCart({ withinMutation: true }); else location.assign(root + 'cart');
            } catch { if (added) location.assign(root + 'cart'); else status.textContent = L.failed; }
            finally { S.cartBusy = false; add.disabled = false; schedule(); }
          });
          row.append(link, add); box.append(row);
        }
        box.append(status); box.hidden = false;
      }
    } catch { if (request === sequence) boxes.forEach(b => b.hidden = true); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(cartExtras, 120); }
  document.addEventListener('sx:cart-synchronized', schedule);
  document.addEventListener('click', e => { if (e.target.closest('.smp-action--cart')) schedule(); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('cart-items,cart-drawer-items,.cart__blocks,.drawer__footer,#product-grid,[data-sx-tag-filters],[data-sx-search-recovery]') || n.querySelector?.('cart-items,cart-drawer-items,[data-sx-tag-filters],[data-sx-search-recovery]'))))) { filterLinks(); recoverSearch(); schedule(); }
  }).observe(document.getElementById('MainContent')?.parentElement || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => { filterLinks(); recoverSearch(); schedule(); });
  filterLinks(); recoverSearch(); schedule();
})();

